<template>
  <v-container fluid>
    <el-tabs type="border-card" @tab-click="handleClick">
      <el-tab-pane label="ข้อมูลทั่วไป">
        <div>{{poi}}</div>
        <div v-if="poi!=null">
          <el-form ref="form" :model="poi" label-width="120px">
            <el-form-item label="สถานะ">
              <el-input size="mini" v-model="poi.poi_status"></el-input>
            </el-form-item>
            <el-form-item label="ประเภท">
              <el-input size="mini" v-model="poi.poi_type"></el-input>
            </el-form-item>
            <el-form-item label="แหล่งที่มา">
              <el-input size="mini" v-model="poi.poi_source"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-tab-pane>
      <el-tab-pane label="ภาษา">
        <template v-if="poi!=null">
          <el-card class="box-card mb-3" v-for="(item, index) in poi.poi_info" v-bind:key="index">
            <v-layout>
              <v-flex md8>
                <el-form ref="form" :model="poi" label-width="120px">
                  <template v-for="(value, propertyName) in item">
                    <el-form-item
                      v-if="propertyName!='poi_other_json'"
                      :label="propertyName"
                      v-bind:key="propertyName"
                    >
                      <el-input
                        type="textarea"
                        :rows="4"
                        v-if="propertyName=='poi_excerpt'"
                        size="mini"
                        v-model="item[propertyName]"
                      ></el-input>
                      <el-input
                        v-else
                        size="mini"
                        v-model="item[propertyName]"
                        :disabled="['id', 'lang'].includes(propertyName)"
                      ></el-input>
                    </el-form-item>
                  </template>
                  <el-form-item>
                    <el-button type="primary" size="small" @click="saveLang(item)">Save</el-button>
                  </el-form-item>
                </el-form>
              </v-flex>
            </v-layout>
          </el-card>
        </template>
      </el-tab-pane>
      <el-tab-pane label="รูปภาพ">
        <div>
          <el-upload
            :action="`http://delivery-api:3002/cms/poi/`+poi_id+`/upload`"
            list-type="picture-card"
            :auto-upload="true"
          >
            <i slot="default" class="el-icon-plus"></i>
            <div slot="file" slot-scope="{file}">
              <img class="el-upload-list__item-thumbnail" :src="file.url" alt />
              <span class="el-upload-list__item-actions">
                <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                  <i class="el-icon-zoom-in"></i>
                </span>
                <span class="el-upload-list__item-delete" @click="handleDownload(file)">
                  <i class="el-icon-download"></i>
                </span>
                <span class="el-upload-list__item-delete" @click="handleRemove(file)">
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
          </el-upload>
        </div>
      </el-tab-pane>
    </el-tabs>
  </v-container>
</template>

<script>
import Service from "../../services";
export default {
  components: {},
  props: ["poi_id"],
  data() {
    return {
      poi: null
    };
  },
  created() {
    Service.Cms.getPoiDetail(this.poi_id).then(res => {
      this.poi = res.data;
      console.log(this.poi);
    });
  },
  methods: {
    saveLang(item) {
      console.log(item);
      Service.Cms.editPoiInfo(item).then(res => {
        console.log(res);
      });
    },
    handleClick(tab, event) {
      //console.log(tab, event);
    },
    handleUploadChange(file, fileList) {
      this.fileList = fileList.slice(-3);
      console.log(file);
      let data = {
        poi_id: this.poi.poi_id,
        file: file.url
      };
      Service.Cms.uploadPoiImage(data).then(res => {
        console.log(res);
      });
    },
    handleRemove(file) {
      console.log(file);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleDownload(file) {
      console.log(file);
    }
  }
};
</script>